import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Box, Button, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { listOptionsButton, menuItemIcon, pageHeaderContainer } from "../../styles/frequentListStyles";
import PageTitle from "../Common/PageTitle";

export const FrequentListHeader = ({ onNewList, onOpenMenu, listMenuAnchorEl, listMenuOpen, onCloseMenu, onEditList, onAddToCart, canDelete, onDeleteList }) => {
  const { t } = useTranslation();

  // Always close the menu before performing actions to prevent focus issues
  const handleEditClick = useCallback(() => {
    onCloseMenu();
    onEditList();
  }, [onCloseMenu, onEditList]);

  const handleAddToCartClick = useCallback(() => {
    onCloseMenu();
    onAddToCart();
  }, [onCloseMenu, onAddToCart]);

  const handleDeleteClick = useCallback(() => {
    onCloseMenu();
    onDeleteList();
  }, [onCloseMenu, onDeleteList]);

  return (
    <Box sx={pageHeaderContainer}>
      <PageTitle text={t("frequentItems.frequentlyBoughtItems")} />
      <Box>
        <Button variant="outlined" startIcon={<AddCircleOutlineIcon />} onClick={onNewList} sx={{ mr: 1 }}>
          {t("frequentItems.newList")}
        </Button>
        <IconButton
          aria-label="list-options"
          aria-controls={listMenuOpen ? "list-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={listMenuOpen ? "true" : undefined}
          onClick={onOpenMenu}
          sx={listOptionsButton}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="list-menu"
          anchorEl={listMenuAnchorEl}
          open={listMenuOpen}
          onClose={onCloseMenu}
          slotProps={{
            list: { "aria-labelledby": "list-options" },
          }}
        >
          <MenuItem onClick={handleEditClick}>
            <ListItemIcon sx={menuItemIcon}>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("frequentItems.editList")}</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleAddToCartClick}>
            <ListItemIcon sx={menuItemIcon}>
              <ShoppingCartIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("frequentItems.addAllToCart")}</ListItemText>
          </MenuItem>
          {canDelete && (
            <MenuItem onClick={handleDeleteClick}>
              <ListItemIcon sx={menuItemIcon}>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t("frequentItems.deleteList")}</ListItemText>
            </MenuItem>
          )}
        </Menu>
      </Box>
    </Box>
  );
};
